import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

const getUserNameKey = (userId: string | undefined) => ['user-name', userId];

export const useUserName = (userId: string | undefined) => {
    return useQuery({
        queryKey: getUserNameKey(userId),
        enabled: !!userId,
        queryFn: async () => {
            const { data, error } = await supabaseClient.rpc('get_user_name', { p_user_id: userId } as any);
            if (error) throw error;
            return data ?? null;
        },
        staleTime: 5 * 60 * 1000,
    });
};
